import {getSeededRandom} from "../utils/DataUtilities";
import {useContext, useMemo} from "react";
import {StoreContext} from "../stores/StoreLoader";
import {useHeroTerrace} from "./useHeroTerrace";

export function useHeroMediaItem(isWelcomePage) {
    const {organizationStore} = useContext(StoreContext);

    const heroTerrace = useHeroTerrace();

    return useMemo(() => {
        let customMedia = [], mediaRegistry = [];
        if (isWelcomePage) {
            customMedia = organizationStore.hero.filter(media => media.enabled);
            mediaRegistry = organizationStore.organization.media;
        } else if (organizationStore.currentOrganization.json_data?.terracedGrid?.enabled) {
            if (heroTerrace) {
                customMedia = heroTerrace.media.filter(media => media.enabled);
                mediaRegistry = heroTerrace.media_registry;
            }
        }
        if (customMedia.length > 0) {
            // if there are custom media, pick one randomly
            return getSeededRandom(customMedia);
        } else {
            return getSeededRandom(mediaRegistry);
        }
    }, []);
}
